module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner02-13e0abbe06c098b5c75f5a2606f0cbf9.png";